import { render, staticRenderFns } from "./userRejections.vue?vue&type=template&id=034e5632&scoped=true&lang=html&"
import script from "./userRejections.vue?vue&type=script&lang=js&"
export * from "./userRejections.vue?vue&type=script&lang=js&"
import style0 from "./userRejections.vue?vue&type=style&index=0&id=034e5632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034e5632",
  null
  
)

export default component.exports